import axios from "axios";
import * as types from '../constants/ActionTypes';
import { toast } from 'react-toastify';

// Url's
const getProductReviewUrl = `${process.env.REACT_APP_API_URL}mobileshop/csacatalog/save-product-reviews`;

// Actions
const productReviewRequested = () => ({
    type: types.SUBMITREVIEW_REQUEST
  });

const productReviewSuccess = data => ({
    type: types.SUBMITREVIEW_SUCCESS,
    data
  });
    
const productReviewFailure = error => ({
    type: types.SUBMITREVIEW_FAILURE,
    error
  });

// API
export const saveProductReview = (options) => {
    return dispatch => {
      dispatch(productReviewRequested());
      axios.post(getProductReviewUrl, options, {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
            //'Content-Type': 'application/json; charset=UTF-8'
          },
      })
        .then(res => {
          if (res.data.ack === "Success") {
            dispatch(productReviewSuccess(res.data.results));
            toast.error(`Success - Thanks for submitting review!`);
          } else if (res.data.ack === "Failure") {
            toast.error(`Failed - ${res.data.status.message}`);
            dispatch(productReviewFailure(res.data.status));
          } 
        })
        .catch(err => {
            throw err;
          // dispatch(addTodoFailure(err.message));
        });
    };
  };